import { isObject, isString } from 'radash';

type IncomingRnMessage = {
  type?: string;
  payload?: unknown;
};

const isIncomingRnMessage = (value: unknown): value is IncomingRnMessage => {
  if (!isObject(value)) {
    return false;
  }

  if ('type' in value && value.type !== undefined && !isString(value.type)) {
    return false;
  }

  return true;
};

export const parseRnMessageData = (data: unknown): IncomingRnMessage | null => {
  try {
    const parsed = typeof data === 'string' ? JSON.parse(data) : data;
    return isIncomingRnMessage(parsed) ? parsed : null;
  } catch {
    return null;
  }
};
